import { all } from 'redux-saga/effects';
import home from '../modules/Home/saga';


export default function* rootSaga() {
  yield all([
    ...home,
  ]);
}
